// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"0e3bc99a","645":"b04e04bf"}[chunkId] + ".chunk.js";
};